import React, { useState, useEffect } from 'react';


const ModernResumePreview = ({ componentRef, resumeData = {}, onImageUpload }) => {
  // Process highlighting markers from AI response
 

  const {
    profile_image_url,
    full_name, job_title, email, phone, location, website,
    professional_summary,
    professional_skills,
    technical_skills,
    structured_skills,
    experience,
    relevant_experience,
    education,
    projects,
    achievements,
    certifications,
    languages,
    interests,
    publications,
    volunteer_work,
    additional_info,
    references,
    skills = {},
    key_skills = [],
    websites = [],
    github,
    linkedin,
    hackerrank,
    leetcode
  } = resumeData || {};

  const {
    programming_languages = [],
    frameworks = [],
    tools = [],
    ai_ml_technologies = []
  } = skills || {};

  const isUploadedResume = resumeData && Object.keys(resumeData).length > 0 && !resumeData.isTemplate;
  
  // Enhanced logic to detect when to show user data
  const shouldShowUserData = resumeData && (
      !resumeData.isTemplate || 
      resumeData.full_name || 
      resumeData.job_title ||
      resumeData.email || 
      resumeData.phone || 
      resumeData.location ||
      resumeData.website ||
      resumeData.websites ||
      resumeData.professional_summary ||
      resumeData.professional_skills ||
      resumeData.technical_skills ||
      resumeData.projects ||
      resumeData.education ||
      resumeData.experience ||
      resumeData.skills ||
      resumeData.key_skills ||
      resumeData.achievements ||
      resumeData.certifications ||
      resumeData.languages
  );

  return (
    <div id="section-to-print" className="resume-preview modern-print">
      <div className="modern-resume-container modern-resume-paper" ref={componentRef} style={{
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        fontSize: '9pt',
        lineHeight: '1.3',
        color: '#2c3e50',
        backgroundColor: 'white',
        width: '210mm',
        minHeight: '297mm', // Set to A4 height to ensure background fills page
        boxShadow: 'none',
        margin: '0',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'stretch',
        position: 'relative' // For pseudo-element positioning
      }}>
        
        {/* Left Sidebar - Fixed width, extends to full height */}
        <div style={{
          width: '34%',
          backgroundColor: '#2c3e50',
          color: '#FFFFFF',
          padding: '40px 25px',
          minHeight: '100%', // Fill container height
          display: 'flex',
          flexDirection: 'column'
        }}>
        
        {/* Profile Image */}
        <div style={{
          width: '120px',
          height: '120px',
          borderRadius: '50%',
          margin: '0 auto 30px auto',
          border: '4px solid #FFFFFF',
          overflow: 'hidden',
          backgroundColor: '#34495e',
          position: 'relative',
          cursor: shouldShowUserData ? 'pointer' : 'default',
          transition: 'all 0.3s ease'
        }}>
          {profile_image_url ? (
            <img 
              src={profile_image_url} 
              alt="Profile" 
              style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
            />
          ) : shouldShowUserData ? (
            // Upload placeholder for user data (when resume is uploaded)
            <div 
              style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#34495e',
                color: '#FFFFFF',
                textAlign: 'center',
                padding: '10px',
                boxSizing: 'border-box',
                transition: 'all 0.3s ease',
                position: 'relative',
                overflow: 'hidden'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#2c3e50';
                e.target.style.transform = 'scale(1.05)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#34495e';
                e.target.style.transform = 'scale(1)';
              }}
              onClick={() => {
                if (onImageUpload) {
                  // Use the provided upload function
                  const fileInput = document.createElement('input');
                  fileInput.type = 'file';
                  fileInput.accept = 'image/*';
                  fileInput.onchange = (e) => {
                    const file = e.target.files[0];
                    if (file) {
                      onImageUpload(file);
                    }
                  };
                  fileInput.click();
                }
              }}
            >
              {/* Human contact placeholder image */}
              <div style={{
                width: '80px',
                height: '80px',
                borderRadius: '50%',
                backgroundColor: '#FFFFFF',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '8px',
                overflow: 'hidden'
              }}>
                <svg 
                  width="50" 
                  height="50" 
                  viewBox="0 0 24 24" 
                  fill="none"
                  style={{ color: '#34495e' }}
                >
                  <path 
                    d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" 
                    fill="currentColor"
                  />
                </svg>
              </div>
              <span style={{ fontSize: '8px', fontWeight: 'bold', lineHeight: '1.2' }}>
                Upload your image
              </span>
            </div>
          ) : (
            // Default template image (when viewing templates without uploading)
            <div className="header-profile-placeholder">
              <img src="./english.jpeg" alt="Profile" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
          )}
        </div>

        {/* Contact Section */}
        <div style={{ marginBottom: '35px' }}>
          <h2 style={{ 
            fontSize: '13px', 
            fontWeight: 'bold', 
            marginBottom: '12px', 
            textTransform: 'uppercase', 
            letterSpacing: '1px', 
            borderBottom: '2px solid #FFFFFF', 
            paddingBottom: '6px' 
          }}>
            CONTACT
          </h2>
          <div style={{ fontSize: '9pt', lineHeight: '1.5' }}>
            {shouldShowUserData && phone && <p style={{ margin: '0 0 8px 0' }}>📞 {phone}</p>}
            {shouldShowUserData && email && <p style={{ margin: '0 0 8px 0', wordBreak: 'break-all' }}>✉️ {email}</p>}
            {shouldShowUserData && location && <p style={{ margin: '0 0 8px 0' }}>📍 {location}</p>}
            {shouldShowUserData && website && <p style={{ margin: '0', wordBreak: 'break-all' }}>🌐 {website}</p>}
          </div>
          
          {/* Social Media Links */}
          {shouldShowUserData && (github || linkedin || hackerrank || leetcode) && (
            <div style={{ marginTop: '12px' }}>
              <h3 style={{ 
                fontSize: '11px', 
                fontWeight: 'bold', 
                marginBottom: '8px', 
                textTransform: 'uppercase', 
                letterSpacing: '0.5px',
                borderBottom: '1px solid rgba(255,255,255,0.3)',
                paddingBottom: '3px'
              }}>
                PROFESSIONAL LINKS
              </h3>
              <div style={{ fontSize: '8pt', lineHeight: '1.4' }}>
                {github && (
                  <p style={{ margin: '0 0 4px 0' }}>
                    <span style={{ marginRight: '6px' }}>🔗</span>
                    <a href={github} target="_blank" rel="noopener noreferrer" style={{ color: '#FFFFFF', textDecoration: 'none' }}>
                      GitHub
                    </a>
                  </p>
                )}
                {linkedin && (
                  <p style={{ margin: '0 0 4px 0' }}>
                    <span style={{ marginRight: '6px' }}>🔗</span>
                    <a href={linkedin} target="_blank" rel="noopener noreferrer" style={{ color: '#FFFFFF', textDecoration: 'none' }}>
                      LinkedIn
                    </a>
                  </p>
                )}
                {hackerrank && (
                  <p style={{ margin: '0 0 4px 0' }}>
                    <span style={{ marginRight: '6px' }}>🔗</span>
                    <a href={hackerrank} target="_blank" rel="noopener noreferrer" style={{ color: '#FFFFFF', textDecoration: 'none' }}>
                      HackerRank
                    </a>
                  </p>
                )}
                {leetcode && (
                  <p style={{ margin: '0 0 4px 0' }}>
                    <span style={{ marginRight: '6px' }}>🔗</span>
                    <a href={leetcode} target="_blank" rel="noopener noreferrer" style={{ color: '#FFFFFF', textDecoration: 'none' }}>
                      LeetCode
                    </a>
                  </p>
                )}
              </div>
            </div>
          )}

          {/* Websites/Links */}
          {shouldShowUserData && websites && websites.length > 0 && (
            <div style={{ marginTop: '12px' }}>
              <h3 style={{ 
                fontSize: '11px', 
                fontWeight: 'bold', 
                marginBottom: '8px', 
                textTransform: 'uppercase', 
                letterSpacing: '0.5px',
                borderBottom: '1px solid rgba(255,255,255,0.3)',
                paddingBottom: '3px'
              }}>
                WEBSITES/LINKS
              </h3>
              <div style={{ fontSize: '8pt', lineHeight: '1.4' }}>
                {websites.map((site, index) => (
                  <p key={index} style={{ margin: '0 0 4px 0', wordBreak: 'break-all' }}>
                    🌐 <a href={site} target="_blank" rel="noopener noreferrer" style={{ color: '#FFFFFF', textDecoration: 'none' }}>
                      {site.replace(/^https?:\/\//, '').replace(/^www\./, '')}
                    </a>
                  </p>
                ))}
              </div>
            </div>
          )}
        </div>
        
        {/* Education Section */}
        <div style={{ marginBottom: '35px' }}>
          <h2 style={{ 
            fontSize: '13px', 
            fontWeight: 'bold', 
            marginBottom: '12px', 
            textTransform: 'uppercase', 
            letterSpacing: '1px', 
            borderBottom: '2px solid #FFFFFF', 
            paddingBottom: '6px' 
          }}>
            EDUCATION
          </h2>
          {(education || []).map((edu, index) => (
            <div key={index} style={{ marginBottom: '18px' }}>
              <p style={{ margin: '0 0 3px 0', fontSize: '9pt', fontWeight: 'bold' }}>
                {edu.start_date || edu.start_year || "2029"} - {edu.graduation_date || edu.end_date || edu.end_year || "2030"}
              </p>
              <p style={{ margin: '0 0 3px 0', fontSize: '10pt', fontWeight: 'bold' }}>
                {edu.institution || "WARDIERE UNIVERSITY"}{edu.location ? `, ${edu.location}` : ""}
              </p>
              <p style={{ margin: 0, fontSize: '9pt', paddingLeft: '8px', textIndent: '-8px' }}>
                • {edu.degree || "Master of Business Management"}
              </p>
              {(edu.cgpa || edu.gpa) && (
                <p style={{ margin: '3px 0 0 0', fontSize: '8pt', fontStyle: 'italic' }}>
                  GPA: {edu.cgpa || edu.gpa}
                </p>
              )}
              {edu.coursework && edu.coursework.length > 0 && (
                <p style={{ margin: '3px 0 0 0', fontSize: '8pt', fontStyle: 'italic' }}>
                  Coursework: {edu.coursework.join(', ')}
                </p>
              )}
            </div>
          ))}
        </div>

        {/* Skills Section */}
        <div style={{ marginBottom: '35px' }}>
          <h2 style={{ 
            fontSize: '13px', 
            fontWeight: 'bold', 
            marginBottom: '12px', 
            textTransform: 'uppercase', 
            letterSpacing: '1px', 
            borderBottom: '2px solid #FFFFFF', 
            paddingBottom: '6px' 
          }}>
            SKILLS
          </h2>
          
          <div style={{ fontSize: '9pt' }}>
            {/* Categorized Skills Display */}
            {/* Programming Languages */}
            {programming_languages && programming_languages.length > 0 && (
              <div style={{ marginBottom: '8px' }}>
                <p style={{ margin: '0 0 4px 0', fontWeight: 'bold', fontSize: '8pt' }}>Programming Languages:</p>
                {programming_languages.map((skill, index) => (
                  <p key={index} style={{ margin: '0 0 2px 0', paddingLeft: '8px', textIndent: '-8px' }}>
                    • {skill}
                  </p>
                ))}
              </div>
            )}

            {/* Frameworks */}
            {frameworks && frameworks.length > 0 && (
              <div style={{ marginBottom: '8px' }}>
                <p style={{ margin: '0 0 4px 0', fontWeight: 'bold', fontSize: '8pt' }}>Frameworks:</p>
                {frameworks.map((skill, index) => (
                  <p key={index} style={{ margin: '0 0 2px 0', paddingLeft: '8px', textIndent: '-8px' }}>
                    • {skill}
                  </p>
                ))}
              </div>
            )}

            {/* Tools */}
            {tools && tools.length > 0 && (
              <div style={{ marginBottom: '8px' }}>
                <p style={{ margin: '0 0 4px 0', fontWeight: 'bold', fontSize: '8pt' }}>Tools:</p>
                {tools.map((skill, index) => (
                  <p key={index} style={{ margin: '0 0 2px 0', paddingLeft: '8px', textIndent: '-8px' }}>
                    • {skill}
                  </p>
                ))}
              </div>
            )}

            {/* AI/ML Technologies */}
            {ai_ml_technologies && ai_ml_technologies.length > 0 && (
              <div style={{ marginBottom: '8px' }}>
                <p style={{ margin: '0 0 4px 0', fontWeight: 'bold', fontSize: '8pt' }}>AI/ML Technologies:</p>
                {ai_ml_technologies.map((skill, index) => (
                  <p key={index} style={{ margin: '0 0 2px 0', paddingLeft: '8px', textIndent: '-8px' }}>
                    • {skill}
                  </p>
                ))}
              </div>
            )}

            {/* Professional Skills (for template defaults only) */}
            {resumeData.isTemplate && professional_skills && professional_skills.length > 0 && (
              <div style={{ marginBottom: '8px' }}>
                <p style={{ margin: '0 0 4px 0', fontWeight: 'bold', fontSize: '8pt' }}>Professional Skills:</p>
                {professional_skills.map((skill, index) => (
                  <p key={index} style={{ margin: '0 0 2px 0', paddingLeft: '8px', textIndent: '-8px' }}>
                    • {skill}
                  </p>
                ))}
              </div>
            )}

            {/* Technical Skills (for template defaults only) */}
            {resumeData.isTemplate && technical_skills && technical_skills.length > 0 && (
              <div style={{ marginBottom: '8px' }}>
                <p style={{ margin: '0 0 4px 0', fontWeight: 'bold', fontSize: '8pt' }}>Technical Skills:</p>
                {technical_skills.map((skill, index) => (
                  <p key={index} style={{ margin: '0 0 2px 0', paddingLeft: '8px', textIndent: '-8px' }}>
                    • {skill}
                  </p>
                ))}
              </div>
            )}

            {/* Fallback to structured_skills for backward compatibility */}
            {(!programming_languages || programming_languages.length === 0) && 
             (!frameworks || frameworks.length === 0) && 
             (!tools || tools.length === 0) && 
             (!ai_ml_technologies || ai_ml_technologies.length === 0) && 
             (!professional_skills || professional_skills.length === 0) &&
             (!technical_skills || technical_skills.length === 0) &&
             structured_skills && (
              <>
                {/* Programming Languages */}
                {structured_skills.programming_languages && structured_skills.programming_languages.length > 0 && (
                  <div style={{ marginBottom: '8px' }}>
                    <p style={{ margin: '0 0 4px 0', fontWeight: 'bold', fontSize: '8pt' }}>Programming Languages:</p>
                    {structured_skills.programming_languages.map((skill, index) => (
                      <p key={index} style={{ margin: '0 0 2px 0', paddingLeft: '8px', textIndent: '-8px' }}>
                        • {skill}
                      </p>
                    ))}
                  </div>
                )}

                {/* Frameworks */}
                {structured_skills.frameworks && structured_skills.frameworks.length > 0 && (
                  <div style={{ marginBottom: '8px' }}>
                    <p style={{ margin: '0 0 4px 0', fontWeight: 'bold', fontSize: '8pt' }}>Frameworks:</p>
                    {structured_skills.frameworks.map((skill, index) => (
                      <p key={index} style={{ margin: '0 0 2px 0', paddingLeft: '8px', textIndent: '-8px' }}>
                        • {skill}
                      </p>
                    ))}
                  </div>
                )}

                {/* Tools */}
                {structured_skills.tools && structured_skills.tools.length > 0 && (
                  <div style={{ marginBottom: '8px' }}>
                    <p style={{ margin: '0 0 4px 0', fontWeight: 'bold', fontSize: '8pt' }}>Tools:</p>
                    {structured_skills.tools.map((skill, index) => (
                      <p key={index} style={{ margin: '0 0 2px 0', paddingLeft: '8px', textIndent: '-8px' }}>
                        • {skill}
                      </p>
                    ))}
                  </div>
                )}

                {/* AI/ML Technologies */}
                {structured_skills.ai_ml_technologies && structured_skills.ai_ml_technologies.length > 0 && (
                  <div style={{ marginBottom: '8px' }}>
                    <p style={{ margin: '0 0 4px 0', fontWeight: 'bold', fontSize: '8pt' }}>AI/ML Technologies:</p>
                    {structured_skills.ai_ml_technologies.map((skill, index) => (
                      <p key={index} style={{ margin: '0 0 2px 0', paddingLeft: '8px', textIndent: '-8px' }}>
                        • {skill}
                      </p>
                    ))}
                  </div>
                )}
              </>
            )}
          </div>
        </div>

        {/* Languages Section */}
        {/* Removed - only show if user has languages data */}
      </div>

             {/* Right Main Content - Extends to full height */}
       <div style={{ 
         width: '66%', 
         padding: '40px 35px',
         minHeight: '100%', // Fill container height
         display: 'flex',
         flexDirection: 'column',
         backgroundColor: 'white' // Explicit white background
       }}>
        
        {/* Main Header */}
        <div style={{ marginBottom: '25px' }}>
          <h1 style={{ 
            fontSize: '28px', 
            fontWeight: 'bold', 
            margin: '0', 
            textTransform: 'uppercase', 
            letterSpacing: '2px', 
            color: '#2c3e50' 
          }}>
            {shouldShowUserData && full_name ? full_name : "RICHARD SWART"}
          </h1>
          <div style={{ 
            width: '60px', 
            height: '2px', 
            backgroundColor: '#2c3e50', 
            margin: '6px 0' 
          }}></div>
          <p style={{ 
            fontSize: '11pt', 
            margin: '0', 
            letterSpacing: '1px', 
            textTransform: 'uppercase',
            color: '#7f8c8d'
          }}>
            {shouldShowUserData && job_title ? job_title : "MARKETING MANAGER"}
          </p>
        </div>

        {/* Profile/Summary */}
        <div style={{ marginBottom: '25px' }}>
          <h2 style={{ 
            fontSize: '13px', 
            fontWeight: 'bold', 
            marginBottom: '8px', 
            textTransform: 'uppercase', 
            letterSpacing: '1px', 
            color: '#2c3e50', 
            borderBottom: '2px solid #bdc3c7', 
            paddingBottom: '4px' 
          }}>
            PROFILE
          </h2>
          <p style={{ fontSize: '9pt', lineHeight: '1.4', margin: 0, textAlign: 'justify' }}>
            {shouldShowUserData && professional_summary ? professional_summary : "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation."}
          </p>
        </div>

        {/* Work Experience - Grows naturally */}
        <div style={{ marginBottom: '25px' }}>
          <h2 style={{ 
            fontSize: '13px', 
            fontWeight: 'bold', 
            marginBottom: '12px', 
            textTransform: 'uppercase', 
            letterSpacing: '1px', 
            color: '#2c3e50', 
            borderBottom: '2px solid #bdc3c7', 
            paddingBottom: '4px' 
          }}>
            WORK EXPERIENCE
          </h2>
          {((experience || relevant_experience) || [
            {
              company: "Borcelle Studio",
              position: "Marketing Manager & Specialist",
              start_date: "2030",
              end_date: "PRESENT",
              description_points: [
                "Develop and execute comprehensive marketing strategies and campaigns that align with the company's goals and objectives.",
                "Lead, mentor, and manage a high-performing marketing team, fostering a collaborative and results-driven work environment.",
                "Monitor brand consistency across marketing channels and materials."
              ]
            },
            {
              company: "Fauget Studio",
              position: "Marketing Manager & Specialist",
              start_date: "2025",
              end_date: "2029",
              description_points: [
                "Create and manage the marketing budget, ensuring efficient allocation of resources and maximizing ROI.",
                "Oversee market research to identify emerging trends, customer needs, and competitive strategies.",
                "Monitor brand consistency across marketing channels and materials."
              ]
            },
            {
              company: "Studio Shodwe",
              position: "Marketing Manager & Specialist",
              start_date: "2024",
              end_date: "2025",
              description_points: [
                "Develop and maintain strong relationships with partners, agencies, and vendors to support marketing initiatives.",
                "Monitor and maintain brand consistency across all marketing channels and materials."
              ]
            }
          ]).map((exp, index) => (
            <div key={index} style={{ 
              marginBottom: '20px', 
              display: 'flex', 
              position: 'relative', 
              paddingLeft: '20px'
            }}>
              <div style={{ 
                position: 'absolute', 
                left: 0, 
                top: '4px', 
                width: '1.5px', 
                height: index === (experience || []).length - 1 ? '60px' : '100%', 
                backgroundColor: '#bdc3c7' 
              }}></div>
              <div style={{ 
                position: 'absolute', 
                left: '-3px', 
                top: '4px', 
                width: '7px', 
                height: '7px', 
                backgroundColor: '#2c3e50', 
                borderRadius: '50%' 
              }}></div>
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: '2px' }}>
                  <h3 style={{ fontSize: '10pt', fontWeight: 'bold', margin: 0, color: '#2c3e50' }}>
                    {exp.company}
                  </h3>
                  <p style={{ fontSize: '9pt', margin: 0, color: '#7f8c8d' }}>
                    {exp.start_date} - {exp.end_date}
                  </p>
                </div>
                <p style={{ fontStyle: 'italic', fontSize: '9pt', margin: '0 0 6px 0', color: '#7f8c8d' }}>
                  {exp.position}
                </p>
                <div style={{ fontSize: '9pt' }}>
                  {(exp.description_points || []).map((point, pIndex) => (
                    <p key={pIndex} style={{ margin: '0 0 4px 0', paddingLeft: '8px', textIndent: '-8px', lineHeight: '1.3' }}>
                      • {point}
                    </p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {/* Achievements - Grows naturally */}
        {achievements && achievements.length > 0 && (
          <div style={{ marginBottom: '25px' }}>
            <h2 style={{ 
              fontSize: '13px', 
              fontWeight: 'bold', 
              marginBottom: '12px', 
              textTransform: 'uppercase', 
              letterSpacing: '1px', 
              color: '#2c3e50', 
              borderBottom: '2px solid #bdc3c7', 
              paddingBottom: '4px' 
            }}>
              ACHIEVEMENTS
            </h2>
            <div style={{ fontSize: '9pt' }}>
              {achievements.map((achievement, index) => (
                <p key={index} style={{ margin: '0 0 6px 0', paddingLeft: '8px', textIndent: '-8px', lineHeight: '1.3' }}>
                  • {achievement}
                </p>
              ))}
            </div>
          </div>
        )}
        
        {/* Certifications - Grows naturally */}
        {certifications && certifications.length > 0 && (
          <div style={{ marginBottom: '25px' }}>
            <h2 style={{ 
              fontSize: '13px', 
              fontWeight: 'bold', 
              marginBottom: '12px', 
              textTransform: 'uppercase', 
              letterSpacing: '1px', 
              color: '#2c3e50', 
              borderBottom: '2px solid #bdc3c7', 
              paddingBottom: '4px' 
            }}>
              CERTIFICATIONS
            </h2>
            <div style={{ fontSize: '9pt' }}>
              {certifications && certifications.length > 0 && certifications.map((cert, index) => {
                // Handle both string certifications and object certifications
                if (typeof cert === 'string') {
                  return (
                    <p key={index} style={{ margin: '0 0 8px 0', paddingLeft: '8px', textIndent: '-8px' }}>
                      • {cert}
                    </p>
                  );
                }
                
                const { name, provider, year } = cert;
                
                return (
                  <div key={index} style={{ marginBottom: '8px' }}>
                    <p style={{ margin: '0 0 2px 0', fontWeight: 'bold' }}>
                      {name}
                    </p>
                    {provider && (
                      <p style={{ margin: '0', color: '#7f8c8d', fontSize: '8pt' }}>
                        {provider}
                      </p>
                    )}
                    {year && (
                      <p style={{ margin: '0', color: '#7f8c8d', fontSize: '8pt' }}>
                        {year}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}
        
        {/* Languages */}
        {languages && languages.length > 0 && (
          <div style={{ marginBottom: '25px' }}>
            <h2 style={{ 
              fontSize: '13px', 
              fontWeight: 'bold', 
              marginBottom: '12px', 
              textTransform: 'uppercase', 
              letterSpacing: '1px', 
              color: '#2c3e50', 
              borderBottom: '2px solid #bdc3c7', 
              paddingBottom: '4px' 
            }}>
              LANGUAGES
            </h2>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
              {languages.map((lang, index) => {
                // Handle both string and object formats
                if (typeof lang === 'string') {
                  return (
                    <div key={index} style={{ 
                      padding: '6px 12px',
                      backgroundColor: '#f8f9fa',
                      borderRadius: '20px',
                      border: '1px solid #e9ecef'
                    }}>
                      <span style={{ 
                        fontSize: '9pt', 
                        fontWeight: '500',
                        color: '#2c3e50'
                      }}>
                        {lang}
                      </span>
                    </div>
                  );
                }
                
                // ResumeEditor now provides both 'language' and 'name' fields
                return (
                  <div key={index} style={{ 
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '6px 12px',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '20px',
                    border: '1px solid #e9ecef'
                  }}>
                    <span style={{ 
                      fontSize: '9pt', 
                      fontWeight: '500',
                      color: '#2c3e50'
                    }}>
                      {lang.language || lang.name}
                    </span>
                    {lang.proficiency && (
                      <span style={{ 
                        fontSize: '8pt', 
                        color: '#7f8c8d',
                        backgroundColor: '#e9ecef',
                        padding: '2px 6px',
                        borderRadius: '10px'
                      }}>
                        {lang.proficiency}
                      </span>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Interests */}
        {interests && interests.length > 0 && (
          <div style={{ marginBottom: '25px' }}>
            <h2 style={{ 
              fontSize: '13px', 
              fontWeight: 'bold', 
              marginBottom: '12px', 
              textTransform: 'uppercase', 
              letterSpacing: '1px', 
              color: '#2c3e50', 
              borderBottom: '2px solid #bdc3c7', 
              paddingBottom: '4px' 
            }}>
              INTERESTS
            </h2>
            <p style={{ fontSize: '9pt', lineHeight: '1.4', margin: 0 }}>
              {interests.join(', ')}
            </p>
          </div>
        )}

        {/* Publications */}
        {publications && publications.length > 0 && (
          <div style={{ marginBottom: '25px' }}>
            <h2 style={{ 
              fontSize: '13px', 
              fontWeight: 'bold', 
              marginBottom: '12px', 
              textTransform: 'uppercase', 
              letterSpacing: '1px', 
              color: '#2c3e50', 
              borderBottom: '2px solid #bdc3c7', 
              paddingBottom: '4px' 
            }}>
              PUBLICATIONS
            </h2>
            <div style={{ fontSize: '9pt' }}>
              {publications.map((pub, index) => (
                <p key={index} style={{ margin: '0 0 6px 0', paddingLeft: '8px', textIndent: '-8px', lineHeight: '1.3' }}>
                  • {pub}
                </p>
              ))}
            </div>
          </div>
        )}

        {/* Volunteer Work */}
        {volunteer_work && volunteer_work.length > 0 && (
          <div style={{ marginBottom: '25px' }}>
            <h2 style={{ 
              fontSize: '13px', 
              fontWeight: 'bold', 
              marginBottom: '12px', 
              textTransform: 'uppercase', 
              letterSpacing: '1px', 
              color: '#2c3e50', 
              borderBottom: '2px solid #bdc3c7', 
              paddingBottom: '4px' 
            }}>
              VOLUNTEER WORK
            </h2>
            <div style={{ fontSize: '9pt' }}>
              {volunteer_work.map((vol, index) => (
                <p key={index} style={{ margin: '0 0 6px 0', paddingLeft: '8px', textIndent: '-8px', lineHeight: '1.3' }}>
                  • {vol}
                </p>
              ))}
            </div>
          </div>
        )}

        {/* Additional Information */}
        {additional_info && additional_info.length > 0 && (
          <div style={{ marginBottom: '25px' }}>
            <h2 style={{ 
              fontSize: '13px', 
              fontWeight: 'bold', 
              marginBottom: '12px', 
              textTransform: 'uppercase', 
              letterSpacing: '1px', 
              color: '#2c3e50', 
              borderBottom: '2px solid #bdc3c7', 
              paddingBottom: '4px' 
            }}>
              ADDITIONAL INFORMATION
            </h2>
            <div style={{ fontSize: '9pt' }}>
              {additional_info.map((info, index) => (
                <p key={index} style={{ margin: '0 0 6px 0', paddingLeft: '8px', textIndent: '-8px', lineHeight: '1.3' }}>
                  • {info}
                </p>
              ))}
            </div>
          </div>
        )}

        {/* References */}
        {references && references.length > 0 && (
          <div style={{ marginBottom: '25px' }}>
            <h2 style={{ 
              fontSize: '13px', 
              fontWeight: 'bold', 
              marginBottom: '12px', 
              textTransform: 'uppercase', 
              letterSpacing: '1px', 
              color: '#2c3e50', 
              borderBottom: '2px solid #bdc3c7', 
              paddingBottom: '4px' 
            }}>
              REFERENCES
            </h2>
            {references.map((ref, index) => (
              <div key={index} style={{ 
                marginBottom: '15px',
                pageBreakInside: 'avoid'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: '4px' }}>
                  <h3 style={{ fontSize: '10pt', fontWeight: 'bold', margin: 0, color: '#2c3e50', flex: 1 }}>
                    {ref.name || "Reference Name"}
                  </h3>
                  {ref.title && (
                    <span style={{ 
                      fontSize: '9pt', 
                      color: '#7f8c8d', 
                      fontStyle: 'italic',
                      marginLeft: '10px',
                      flexShrink: 0
                    }}>
                      {ref.title}
                    </span>
                  )}
                </div>
                {ref.company && (
                  <p style={{ 
                    fontSize: '9pt', 
                    margin: '0 0 4px 0', 
                    color: '#34495e',
                    fontWeight: '500'
                  }}>
                    {ref.company}
                  </p>
                )}
                <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
                  {ref.email && (
                    <span style={{ 
                      fontSize: '8pt', 
                      color: '#3498db',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px'
                    }}>
                      📧 {ref.email}
                    </span>
                  )}
                  {ref.phone && (
                    <span style={{ 
                      fontSize: '8pt', 
                      color: '#3498db',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px'
                    }}>
                      📞 {ref.phone}
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Projects - Grows naturally with content, no height restrictions */}
        {projects && projects.length > 0 && (
          <div style={{ marginBottom: '25px' }}>
            <h2 style={{ 
              fontSize: '13px', 
              fontWeight: 'bold', 
              marginBottom: '12px', 
              textTransform: 'uppercase', 
              letterSpacing: '1px', 
              color: '#2c3e50', 
              borderBottom: '2px solid #bdc3c7', 
              paddingBottom: '4px' 
            }}>
              PROJECTS
            </h2>
            {projects.map((proj, index) => {
              return (
                <div key={index} style={{ 
                  marginBottom: '15px',
                  // Allow each project to take the space it needs
                  pageBreakInside: 'avoid', // Prevent breaking projects across pages when printing
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: '4px' }}>
                    <h3 style={{ fontSize: '10pt', fontWeight: 'bold', margin: 0, color: '#2c3e50', flex: 1 }}>
                      {proj.title || proj.name || "Untitled Project"}
                    </h3>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexShrink: 0 }}>
                      {proj.year && (
                        <span style={{ 
                          fontSize: '8pt', 
                          color: '#7f8c8d', 
                          fontStyle: 'italic'
                        }}>
                          {proj.year}
                        </span>
                      )}
                      {proj.link && (
                        <a href={proj.link} target="_blank" rel="noopener noreferrer" style={{ 
                          fontSize: '8pt', 
                          color: '#3498db', 
                          textDecoration: 'none'
                        }}>
                          View Project
                        </a>
                      )}
                    </div>
                  </div>
                  <p style={{ 
                    fontSize: '9pt', 
                    margin: '0 0 4px 0', 
                    lineHeight: '1.3',
                    textAlign: 'justify'
                  }}>
                    {proj.description || "No description provided"}
                  </p>
                  {proj.technologies && (
                    <p style={{ 
                      fontSize: '8pt', 
                      margin: 0, 
                      color: '#7f8c8d', 
                      fontStyle: 'italic',
                      lineHeight: '1.2'
                    }}>
                      Technologies: {
                        Array.isArray(proj.technologies) 
                          ? proj.technologies.map((item, idx) => (
                              <span key={idx}>{idx > 0 ? ', ' : ''}{item}</span>
                            ))
                          : typeof proj.technologies === 'string'
                            ? proj.technologies.split(',').map((item, idx) => (
                                <span key={idx}>{idx > 0 ? ', ' : ''}{item.trim()}</span>
                              ))
                            : proj.technologies
                      }
                    </p>
                  )}
                </div>
              );
            })}
        </div>
      )}
      </div>
      </div>
      
      {/* Print styles to fix dark blue background */}
      <style>{`
        @media print {
          @page {
            size: A4;
            margin: 0;
            background: white;
          }
          
          html, body {
            background: white !important;
            margin: 0;
            padding: 0;
          }
          
          #section-to-print {
            background: white !important;
          }
          
          .resume-preview.modern-print {
            background: white !important;
          }
          
          .modern-resume-container.modern-resume-paper {
            background: white !important;
            min-height: auto !important;
            height: auto !important;
            align-items: stretch !important;
            position: relative !important;
          }
          
          .modern-resume-container.modern-resume-paper::before {
            content: "" !important;
            position: fixed !important;
            top: 0 !important;
            left: 0 !important;
            width: 34% !important;
            height: 100% !important;
            background: #2c3e50 !important;
            z-index: 0 !important;
          }
          
          .modern-resume-container.modern-resume-paper > div {
            position: relative !important;
            z-index: 1 !important;
          }
          
          .modern-resume-container.modern-resume-paper > div[style*="width: '34%'"],
          .modern-resume-container.modern-resume-paper > div[style*="width: 34%"] {
            min-height: auto !important;
            height: auto !important;
            background-color: transparent !important;
          }
          
          .modern-resume-container.modern-resume-paper > div[style*="width: '66%'"],
          .modern-resume-container.modern-resume-paper > div[style*="width: 66%"] {
            min-height: auto !important;
            height: auto !important;
            background-color: white !important;
          }
        }
      `}</style>
    </div>
  );
};

export default ModernResumePreview;


     